export enum IntegrationTypes
{
  None = 0,
  SqeptechConnect = 1,
  CPR = 2,
  Lessor = 3,
  Unit4 = 4,
  Visma = 5,
  Teta = 6,
  Promark = 7,
  DalcoAfas = 8,
  TMS = 9,
  FoppenAfas = 12
}
